import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<{ label: string; url?: string }[]>([]);
  breadcrumbs$ = this.breadcrumbsSubject.asObservable();
  private readonly storageKey = 'appBreadcrumbs';

  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    // Check if the platform is a browser
    if (isPlatformBrowser(this.platformId)) {
      const storedBreadcrumbs = sessionStorage.getItem(this.storageKey);
      if (storedBreadcrumbs) {
        this.breadcrumbsSubject.next(JSON.parse(storedBreadcrumbs));
      }
    }
  }

  updateBreadcrumbs( breadcrumbs: { label: string; type?: string; url?: string }[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
    // Check if the platform is a browser
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.setItem(this.storageKey, JSON.stringify(breadcrumbs));
    }
  }

  getBreadCrumbs() {
    return this.breadcrumbsSubject.getValue();
  }

  trimBreadcrumbs(label: string, url?: string) {
    const currentBreadcrumbs = this.breadcrumbsSubject.getValue();
    const index = currentBreadcrumbs.findIndex(
      (breadcrumb) => breadcrumb.label === label
    );
    if (index !== -1) {
      const trimmedBreadcrumbs = currentBreadcrumbs.slice(0, index + 1);
      this.breadcrumbsSubject.next(trimmedBreadcrumbs);
      // Check if the platform is a browser
      if (isPlatformBrowser(this.platformId)) {
        sessionStorage.setItem(this.storageKey, JSON.stringify(trimmedBreadcrumbs));
      }
    }
  }

  clearBreadcrumbs() {
    this.breadcrumbsSubject.next([]);
    // Check if the platform is a browser
    if (isPlatformBrowser(this.platformId)) {
      sessionStorage.removeItem(this.storageKey);
    }
  }
}